import * as React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
function InputSelect(props) {
  const {
    label,
    key_name,
    option,
    handleChange,
    ids,
    list_name,
    opt_list,
    required,
    end_point,
    disab,
    msg,
    defaults,
    newclass,
    style,
    mandatory,
    submit,
    validation,
  } = props;
  const [val, setval] = useState(0);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (props[key_name] !== undefined) {
      setval(props[key_name]);
    }
  }, [props[key_name]]);
  const handleSelect = (event) => {
    const { name, value } = event.target;
    if (value === 0) {
      let events = { target: { name: key_name, value: "" } };
      handleChange(events);
    } else {
      handleChange(event);
    }
  };
  useEffect(() => {
    if (submit) {
      if (validation === "required") {
        setError(!props[key_name]);
      }
    }
  }, [submit]);
  return (
    <div>
      <label className={newclass ? newclass : "label"}>
        {label} {mandatory && <span style={{ color: "red" }}>*</span>}
      </label>
      <FormControl sx={{ width: "100%" }} size="small">
        <Select
          labelId="demo-select-small"
          id={key_name}
          value={val}
          style={{ border: error && submit ? "1px solid red" : "" }}
          className={style ? style : "input-style"}
          defaultValue={0}
          name={key_name}
          onChange={handleSelect}
          disabled={disab}
        >
          <MenuItem value={0}>
            {defaults ? defaults : "Choose any one..."}
          </MenuItem>
          {(option ? option : opt_list?.[end_point])?.map((a, i) => {
            return (
              <MenuItem key={i} value={a[ids]}>
                {a[list_name]}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
}
export default React.memo(InputSelect);
